import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<main>\n  {{yield}}\n</main>\n",{ moduleName: "client-portal/components/practice-website/content-wrapper.hbs" })